export const CURRENCY_SYMBOL: Record<string, string> = {
  JPY: '¥',
  USD: '$',
  TWD: 'NT$',
}

export const getCurrencySymbol = (currency?: string): string => {
  if (!currency) return ''
  return CURRENCY_SYMBOL[currency.toUpperCase()] ?? currency
}
